<template>
  <div class="my-licence">
    <div class="account-card">
      <div class="account-card-header">
        <h4 class="account-card-title">资质证照</h4>
      </div>
      <div class="account-card-action">
        <el-button type="primary" @click="onLink('', 'create')">添加</el-button>
      </div>
      <div class="account-card-body">
        <el-table :data="data" border>
          <el-table-column
            align="center"
            type="index"
            label="序号"
            width="50px"
          >
          </el-table-column>
          <!-- <el-table-column
            prop="licenceTypeName"
            label="证照类型"
            show-overflow-tooltip
            width="160px"
            header-align="center"
          >
          </el-table-column> -->
          <el-table-column
            prop="licenceName"
            label="证照名称"
            show-overflow-tooltip
            header-align="center"
          >
            <template v-slot="scope">
              <span class="cell-link" @click="onLink(scope, 'check')">
                {{ scope.row.licenceName }}
              </span>
            </template>
          </el-table-column>

          <el-table-column
            prop="updateTime"
            label="维护日期"
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="licenceEndTime"
            label="证照有效期至"
            header-align="center"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.isLongValid == 1
                  ? '长期有效'
                  : scope.row.licenceEndTime
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="isValid"
            label="状态 "
            header-align="center"
            align="center"
          >
          </el-table-column>
          <el-table-column
            label="操作"
            header-align="center"
            align="center"
            fixed="right"
          >
            <template v-slot="scope">
              <span @click="onlicenceFromfun(scope, 1)" class="text cellbutton"
                >修改</span
              >
              <span @click="onlicenceFromfun(scope, 2)" class="text cellbutton"
                >删除</span
              >
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          prev-text="上一页"
          next-text="下一页"
          layout=" pager, next, jumper"
          @current-change="onCurrentChange"
          :current-page="pageNum"
          :total="total"
        >
          到第{{ pageNum }}页
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Licence',
  components: {},
  directives: {},
  filters: {},
  mixins: {},
  props: {
    propName: {
      // type: number,
      // default: 0
    }
  },
  data() {
    return {
      linceLength: '',
      data: [],
      total: 0,
      pageNum: 1,
      pageSize: 10
    }
  },
  computed: {},
  watch: {},
  created() {
    this.getLicenceList()
  },
  methods: {
    async getLicenceList() {
      let params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      let data = await this.$api.licence.getLicenceList(params)
      // this.data = data.data;
      if (data.data) {
        this.total = data.total
        this.data = data.data.filter(item => item.licenceName)
      } else {
        this.data = []
        this.total = 0
      }
    },
    onLink(val, pageType) {
      let name = 'LicenceDetail'
      let query
      // debugger
      if (pageType !== 'create') {
        // 资质证照特殊处理
        if (val.$index === 0) {
          query = {
            pageType: pageType,
            ...val.row
          }
        } else {
          query = {
            pageType: pageType,
            id: val.row.id
          }
        }
      } else {
        query = {
          pageType: pageType
        }
      }

      this.$router
        .push({
          name,
          query
        })
        .catch(() => {})
    },
    onlicenceFromfun(scope, type) {
      if (scope.row.licenceFrom === 1) {
        this.$confirm(
          '如需维护营业执照请在会员中心变更，如有疑问请拨打电话400-819-8786。',
          '提示',
          {
            confirmButtonText: '确定',
            showCancelButton: false,
            type: 'warning'
          }
        )
        return
      }
      if (type == 1) {
        this.onLink(scope, 'update')
      } else {
        this.onDelete(scope)
      }
    },
    onDelete(val) {
      this.$confirm('确认删除吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // let params = {
        //   id: val.row.id
        // }

        await this.$api.licence.destroyLicence(val.row.id)
        if (this.data.length == 1) {
          if (this.pageNum > 1) {
            this.pageNum = this.pageNum - 1
          }
        }
        this.getLicenceList()
      })
    },
    onCurrentChange(val) {
      this.pageNum = val
      this.getLicenceList()
    }
  }
}
</script>
<style lang="less" scoped>
.my-licence {
  margin-bottom: 30px;
}
.el-button {
  font-size: 15px;
  padding: 8px 13px;
}
.text {
  margin-right: 8px;
}
</style>
